import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import AuthRoutes from './routes/AuthRoutes';
import UserRoutes from './routes/UserRoutes';
import ProductRoutes from './routes/ProductRoutes';
import MarketPlaceRoutes from './routes/MarketPlaceRoutes';
import LayoutHeader from './components/layout/layoutHeader';
import LayoutSider from './components/layout/layoutSider';
import { userMangement } from './redux/actions/authActions';
import { UPDATE_ROLES } from './constants/actionTypes';
import ManageOrderRoutes from './routes/ManageOrderRoutes';
import SamplingRoutes from './routes/SamplingRoutes';
import CampaignRoutes from './routes/CampaignRoutes';

const { Content } = Layout;

function AppRouter() {
  const [loading, setLoading] = useState(false);
  const isLoggedIn = useSelector((state) =>
    get(state, 'auth.isLoggedIn', false)
  );

  const dispatch = useDispatch();

  const getRoles = () => {
    dispatch(userMangement('list.roles'))
      .then((result) => {
        dispatch({
          type: UPDATE_ROLES,
          payload: get(result, 'data'),
        });
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (isLoggedIn) {
      getRoles();
    }
  }, [isLoggedIn]);

  return (
    <Router>
      <Spin spinning={loading}>
        <Layout className="parent-layout">
          {isLoggedIn && <LayoutSider />}
          <Layout className="content">
            <LayoutHeader isLoggedIn={isLoggedIn} setLoading={setLoading} />
            <Content className="screen-content">
              <AuthRoutes />
              <UserRoutes />
              <ProductRoutes />
              <MarketPlaceRoutes />
              <SamplingRoutes />
              <ManageOrderRoutes />
              <CampaignRoutes />
            </Content>
          </Layout>
        </Layout>
      </Spin>
    </Router>
  );
}
export default AppRouter;
